export default "__VITE_ASSET__CLLmcb4i__"